export default "__VITE_ASSET__Dk1edW$U__"